import { IFactor } from './factor.model';
import {IUserRegion} from './user-region.model';
import {StateDeaNumbers} from './StateDeaNumbers.model';
import {FacilityRoleAssignments} from "./FacilityRoleAssignments.model";

export class User {
  ssoid: string;
  userName: string;
  firstName: string;
  lastName: string;
  password: string;
  email: string;
  status: string;
  sendActivationEmail: boolean;
  changePasswordFirstLogin: boolean;
  passwordSetBy: string;
  factor?: IFactor;
  middleName: string;
  primaryPhone: string;
  ext: string;
  mobilePhone: string;
  userType: string; //Not Set, Corporate, Care Setting
  corporationName: string;
  careSettingName: string;
  role: string;
  primaryDiscipline: string;
  adminToolRole:string;
  userAccessType:string;
  userRegions: IUserRegion[];
  configId: string;
  configName: string;
  federatedIdentity: boolean;
  slProvisioned: boolean;
  trueSenseProvisioned: boolean;
  sigmaCareProvisioned: boolean;
  userStatusId: string;
  federatedLoginID: string;
  title: string;
  prefix: string;
  pdProvisioned: boolean;
  officeId: string;
  customerEmployeeId: string;
  lpcRoles: string[] | null;
  paymentPortalRole: string;
  lpcProvisioned: boolean;
  ppProvisioned: boolean;
  tokenManagement: boolean;
  scimMapping: boolean;
  mcmdRole: string;
  eFormsRole: string;
  rtoRole: string;
  deactivationDate: any;
  physicianNppaEnabled: boolean;
  usesMatrixcare: boolean;
  clinicMedCenter: string;
  fax: string;
  addressLine1: string;
  addressLine2: string;
  pager: string;
  directEmail: string;
  city: string;
  state: string;
  zip: string;
  upin: string;
  taxonomyCode: string;
  licenseNumber: string;
  npi: string;
  taxIdNumber: string;
  medicaidNumber: string;
  stateDeaNumbers: StateDeaNumbers[];
  medicareNumber: string;
  nadeanNumber: string;
  facilityRoleAssignments: FacilityRoleAssignments[] = [];
  solutionsForBusinessModules: string[] | null;
}

export interface McmdRole {
  id: number;
  name: string;
  description: string;
}

export interface SignOnPolicy {
  name?: string;
  description?: string;
  id?: string;
  status?: string;
  priority?: number;
  active?: boolean;
  mfaEnabled?: boolean;
  internalName: string;
}

export interface SignOnPolicyAssignment {
  name?: string;
  description?: string;
  id?: string;
  status?: string;
  priority?: number;
  active?: boolean;
  mfaEnabled?: boolean;
  internalName?: string;
}
